'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const DaySelectionContainer = styled.label`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-radius: ${Spacers.XS}rem;
  border: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
  padding: ${Spacers.BASE}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  cursor: pointer;
`;

export const DaySelectionItem = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
`;

export const DaySelectionSection = styled.div`
  display: flex;
  flex-direction: column;
`;
